import { type FC, useMemo } from "react";
import { Banner, BannerType } from "@stubhub/broadway-web";
import { PriceTrend, type PriceTrendData } from "src/http/types";
import { FormatContent } from "src/shared/components/content";
import { priceTrendBannerRecipe } from "./price-trend-banner.recipe";
import { createPriceMeterIcon } from "./PriceMeterIcon";

interface Props {
  priceTrendData: PriceTrendData;
  locationName: string;
}

/**
 * Price trend banner showing when prices are low for a performer in a given location.
 */
export const PriceTrendBanner: FC<Props> = ({ priceTrendData, locationName }) => {
  const PriceMeterIcon = useMemo(
    () => createPriceMeterIcon(priceTrendData.priceTrend ?? PriceTrend.Low),
    [priceTrendData.priceTrend],
  );

  if (priceTrendData.priceTrend === PriceTrend.Low) {
    return (
      <Banner type={BannerType.Neutral} icon={PriceMeterIcon} classes={priceTrendBannerRecipe()}>
        {/* "Prices are low for events near {0}" */}
        <FormatContent id="cid$#4166659#" params={[locationName]} raw />
      </Banner>
    );
  }

  return null;
};
